import React, { useEffect, useState } from 'react';
import { AutobizPopup } from 'autobiz-strap';
import Markdown from 'markdown-to-jsx';
import { Auth } from '../../../config/configuration/react';
import { REACT_APP_APIOFFICE } from '../../../config';

const AutobizStrapPopup = () => {
  const token = Auth.token();
  const preferredLanguage = Auth.preferredLanguage();
  const country = (Auth.country() || 'en').toLowerCase();
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    fetch(`${REACT_APP_APIOFFICE}/cms/popup?locale=${preferredLanguage}&app=autobizCarcheck&country=${country}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && Object.keys(data).length > 0) {
          setPopupData({
            title: data.title,
            content: data.content,
            ctaLabel: data.cta?.label,
            ctaHref: data.cta?.href,
            ctaCloseLabel: data.ctaClose?.label,
          });
        }
      })
      .catch((err) => console.error(err));
  }, [token, preferredLanguage, country]);

  const hasPopupData = popupData && Object.keys(popupData).some((key) => popupData[key]);

  return (
    <>
      {hasPopupData && (
        <AutobizPopup
          title={popupData.title}
          ctaLabel={popupData.ctaLabel}
          ctaHref={popupData.ctaHref}
          ctaCloseLabel={popupData.ctaCloseLabel}
        >
          <Markdown>{popupData?.content}</Markdown>
        </AutobizPopup>
      )}
    </>
  );
};

export default AutobizStrapPopup;
